import { SEO_DEFAULTS } from '../constants/seo.constants';

export type BreadcrumbCrumb = { label: string; route: string | null };

export function absoluteUrl(path: string | null | undefined): string {
  const base = SEO_DEFAULTS.siteUrl.replace(/\/+$/, '');
  if (!path) return base;
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

export function truncate(text: string, limit = 160): string {
  if (!text) return '';
  return text.length <= limit ? text : `${text.slice(0, limit - 1).trimEnd()}…`;
}

export function buildOrganizationJsonLd(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SEO_DEFAULTS.siteName,
    url: SEO_DEFAULTS.siteUrl,
    logo: absoluteUrl('/images/logo/logo.png'),
    sameAs: [SEO_DEFAULTS.social.instagram, SEO_DEFAULTS.social.facebook],
  };
}

export function buildWebSiteJsonLd(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SEO_DEFAULTS.siteName,
    url: SEO_DEFAULTS.siteUrl,
    inLanguage: 'es-CR',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SEO_DEFAULTS.siteUrl}/buscar?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function buildBreadcrumbJsonLd(items: BreadcrumbCrumb[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.label,
      ...(c.route ? { item: absoluteUrl(c.route) } : {}),
    })),
  };
}
